import { VariantFinishEnum } from "@sorcery/db";

import { CardThreshholds } from "~/components/molecules/card/CardThreshholds";
import type { CollectionCardDTOType } from "~/types/collection";

export const CollectionListTeaserCard = ({
  card,
}: {
  card: CollectionCardDTOType;
}) => {
  const defaultVariant =
    // biome-ignore lint/style/noNonNullAssertion: <explanation>
    card.card.variants.find((v) => v.finish === VariantFinishEnum.Foil) ?? card.card.variants[0]!;
  return (
    <td className="mr-6 flex select-none flex-col">
      <div className={"flex min-h-[20px] flex-row items-center"}>
        <div className="mr-4">
          <span className="inline-block min-w-[30px] px-2">
            {card.groupings.reduce((acc, group) => acc + group.items.length, 0)}
          </span>
          <span
            className={`transition-all ${
              defaultVariant.finish === VariantFinishEnum.Foil && "underline-sparkle relative"
            }`}
          >
            {card.card.name}
          </span>
        </div>

        <div className="flex flex-row">
          <span className="mr-0.5">
            {/* biome-ignore lint/style/noNonNullAssertion: <explanation> */}
            <CardThreshholds guardian={card.card.guardian!} />
          </span>
          {/* Mana cost */}
          {!!card.card.guardian?.cost && (
            <span
              className="mt-[1px] flex h-4 w-4 items-center justify-center rounded-full bg-[#dedcdc] text-center text-black"
              style={{
                boxShadow: "-0 0.12em 0.2em #222, 0.1em 0.08em 0.2em #222",
              }}
            >
              {card.card.guardian.cost}
            </span>
          )}
        </div>
      </div>
    </td>
  );
};
